/**
 * Hook for tracking online/offline status.
 */

import { useEffect } from 'react'
import { useEnergyStore } from '@/stores/useEnergyStore'

export const useNetworkStatus = () => {
  const setIsOnline = useEnergyStore((s) => s.setIsOnline)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [setIsOnline])
}
